import { Injectable } from '@angular/core';
import {BehaviorSubject, from, Observable} from 'rxjs';
import {map, takeWhile} from 'rxjs/operators';
import { OneIncHttpService } from './one-inc-http.service';
import { BillingOptionsService } from './billing-options.service';
import { PaymentDetails } from '../model/payment-details';
import { Router } from '@angular/router';
import { AlertService } from '../core/alert/alert.service';
import {DynamicScriptLoaderService, ScriptConfig} from "./dynamic-script-loader.service";

declare var $: any;

@Injectable({
  providedIn: 'root'
})
export class OneIncService {

  constructor(
      private router: Router,
      private httpService: OneIncHttpService,
      private billingOptionsService: BillingOptionsService,
      private alertService: AlertService,
      private dynamicScriptLoader: DynamicScriptLoaderService,
      private oneIncService: OneIncService
  ) {
  }

  oneIncData: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  oneIncOpen = true;
  paymentDetails: PaymentDetails;

  ONE_INC_ERROR = 'Sorry, we encountered a problem while processing your request. Please try again.';

  private oneIncUrl: string;


  setOneIncUrl(oneIncUrl: string) {
    this.oneIncUrl = oneIncUrl;
  }

  getUrl(): string{
    return `${this.oneIncUrl}Api/Api/Cdn/GenericModalV2/assets/js/PortalOne.js`;
  }

  initializeOneInc(): Observable<boolean>{
    return from(this.dynamicScriptLoader.loadScript('OneInc', this.getUrl()))
      .pipe(map((script: ScriptConfig) => {
        $('#portalOneContainer').portalOne();
        return script.loaded;
      }));
  }

  startOneIncProcess(paymentCategory: string,
                     paymentAmount: number,
                     paymentDate: Date) {
    this.paymentDetails = this.billingOptionsService.getPaymentDetails();
    this.paymentDetails.name = this.billingOptionsService.getSelectedBillee().name;
    this.paymentDetails.policyNumber = this.billingOptionsService.getPolicyNumber();
    this.paymentDetails.paymentDate = paymentDate;
    this.paymentDetails.paymentCategory = paymentCategory;
    this.paymentDetails.amount = paymentAmount;

    this.httpService.getPaymentSessionId()
        .subscribe(response => {
          if (response && response.sessionId) {
            this.setOneIncUrl(response.oneIncUrl);
            this.initializeOneInc().subscribe(() => {
              this.openOneIncModal(
                this.paymentDetails.paymentCategory,
                this.paymentDetails.name,
                this.paymentDetails.holderZip,
                this.paymentDetails.policyNumber,
                response.sessionId
              );
            });
          }
        }, () => {
          this.alertService.error(this.ONE_INC_ERROR);
        });

    this.oneIncData.pipe(takeWhile(() => this.oneIncOpen))
        .subscribe(res => {
          if (res) {
            console.log('oneIncData res', res);
            if (res.event === 'saveCanceled') {
              return;
            } else if (res.event === 'saveComplete') {
              console.log('save complete res', res);
              this.paymentDetails = {...this.paymentDetails, ...res.data};
              console.log('this.paymentDetails', this.paymentDetails);
              this.onSaveComplete(this.paymentDetails);
              this.oneIncOpen = false;
            } else if (res.event === 'error') {
              this.alertService.error(this.ONE_INC_ERROR);
            }
          }
        });
  }

  onSaveComplete(paymentDetails: PaymentDetails) {
    this.httpService.saveOneIncPaymentDetails(paymentDetails)
        .subscribe(res => {
          console.log('saveOneIncPaymentDetails, res', res);
          if (res) {
            this.httpService.getConvenienceFee({
              amount: this.paymentDetails.amount,
              policyNumber: paymentDetails.policyNumber,
              tokenId: paymentDetails.tokenId
            })
                .subscribe(response => {
                  if (response) {
                    console.log('getConvenienceFee  res', response);
                    this.paymentDetails.servicingFee = response.serviceFee;
                    this.paymentDetails.totalPaymentAmount =
                        this.paymentDetails.amount + this.paymentDetails.servicingFee;
                    this.reviewPayment();
                  }
                });
          }
        }, error => {
          this.alertService.error(this.ONE_INC_ERROR, error.toString());
        });
  }

  reviewPayment() {
    this.billingOptionsService.setPaymentDetails(this.paymentDetails);
    this.router.navigateByUrl('/review');
  }

  openOneIncModal(paymentCategory, policyHolderName, billingZip, policyNum, sessionId) {
    $('#portalOneContainer').portalOne();
    const portalOne = $('#portalOneContainer');

    portalOne.data('portalOne')
        .savePaymentMethod({
          paymentCategory,
          billingZip,
          policyHolderName,
          referenceNumber: policyNum,
          confirmationDisplay: 'false',
          sessionId
        });
    this.oneIncEvents();
    this.oneIncSavedPaymentEvents();
  }

  oneIncEvents() {
    const scope = this;
    const portalOne = $('#portalOneContainer');
    portalOne.one('portalOne.load', () => {
      scope.setOneIncData('load', {});
    });

    portalOne.one('portalOne.unload', () => {
      scope.setOneIncData('unload', {});
    });

    portalOne.one('portalOne.error', (e, data) => {
      console.error(new Date() + ' portalOne.error.', data.Description, data.Details);
      scope.setOneIncData('error', data);
    });
  }

  oneIncSavedPaymentEvents() {
    const scope = this;
    const portalOne = $('#portalOneContainer');

    portalOne.one('portalOne.saveComplete', (x, data) => {
      scope.setOneIncData('saveComplete', data);
    });

    portalOne.one('portalOne.saveCanceled', () => {
      scope.setOneIncData('saveCanceled', {});
    });
  }

  setOneIncData(event, data) {
    const oneIncData = {
      event,
      data
    };
    this.oneIncData.next(oneIncData);
  }
}
